module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-view right_auth"
  }, [_c('div', {
    staticClass: "theme"
  }, [_vm._v("我的消息")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.messages.length) ? _c('div', {
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, _vm._l((_vm.messages), function(me, index) {
    return _c('div', {
      staticClass: "block"
    }, [_c('p', {
      staticClass: "seconds"
    }, [_vm._v(_vm._s(me.createTime))]), _vm._v(" "), _c('div', {
      staticClass: "message"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("系统消息")]), _vm._v(" "), _c('p', {
      staticClass: "info"
    }, [_vm._v(_vm._s(me.informationInfo))]), _vm._v(" "), _c('i', {
      staticClass: "close",
      on: {
        "click": function($event) {
          return _vm.remove(me.id)
        }
      }
    }), _vm._v(" "), (me.readStatus == 1) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("未读")]) : _c('span', [_vm._v("已读")])])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.messages.length) ? _c('div', {
    staticClass: "g_empty"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("没有相关消息~")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "page_wrap",
    staticStyle: {
      "margin": "0 0 80px 10px"
    }
  }, [_c('sd-pager', {
    attrs: {
      "page-data": _vm.curPage
    },
    on: {
      "page-change": _vm.pageChange
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d935b44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MessageView.vue
// module id = 853
// module chunks = 1